import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ADMISSIONS_ERROR, GETTING_ADMISSIONS, GET_ADMISSIONS } from "../types"

export const fetchAdmissions = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/admissions?expand=academicSession,fee`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ADMISSIONS,
            payload: true
        })

        const response = await axios.get(url, { headers })

        dispatch({
            type: GET_ADMISSIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ADMISSIONS_ERROR,
            error
        })
    }
}
